import { Divider } from '@fluentui/react-components';
import styled from 'styled-components';


export const TicketDetailsWrapper = styled.div`
  padding: 0px 12px;
  background: ${(props) => props.theme.mainBackgorund};
  height: 100vh;
  width: 100%;
  overflow: auto;
`;

export const TicketDetailsContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 65% 3% 32%;
    height: 90%;
`;

export const TicketDivider = styled(Divider)`
  height: 95%;
  align-self: center;
  ::before{
    border-color: #9299F7;
  },
  ::after{
    border-color: #9299F7;
  },
`;